import Chart from 'chart.js/auto';
const blocks = document.querySelectorAll('section.bar-chart');

function setupChart(id, data, selected_colors, hide_grid_lines, hide_axes, dataset_labels_position, display_total_sum) {
  let textColor = document.querySelector('body.body-bg-blue') ? '#FFFFFF' : '#161614';
  if(document.querySelector('#barChart_' + id + '.bg-color-white')) {
    textColor = '#161614';
  }
  const ctx = document.getElementById('barChart_' + id);

  const datasets = [];
  const colors = selected_colors.split(',') ?? [];
  let labels = [];
  let y_label = '';
  let showLegend = 'false';

  if(data) {
    labels = data.years;
    y_label = data.y_label;

    let data_sets = data.data;

    const dataArray = Object.entries(data_sets).map(([label, yearData]) => ({
      label,
      data: Object.entries(yearData).map(([year, value]) => ({
        x: year,
        y: parseFloat(value)
      }))
    }));

    dataArray.forEach((item, index) => {
      if(item.label != '') {
        showLegend = 'true';
      }     
      datasets.push({
        label: item.label,
        data: item.data,
        backgroundColor: colors[index % colors.length],
        borderColor: colors[index % colors.length],
      });
    });
  }

  let barChart = new Chart(ctx, {
    type: 'bar',
    defaults: {
      color: textColor,
    },
    data: {
      labels: labels,
      datasets: datasets,
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          grid: {
            color: function(context) {
              // Only show the first grid line (index 0)
              if (context.index === 0 && hide_axes != 'true' ) {
                return textColor;
              }
              return 'rgba(0, 0, 0, 0)'; // Transparent for all other lines
            },
            drawTicks: false
          },
          ticks: {
            font: {
              family: "Montserrat, sans-serif",
              size: 16
            },
            color: textColor,
          },
        },
        y: {
          beginAtZero: true,
          stacked: true,
          display: hide_axes === 'true' ? false : true,
          grace: 2,
          title: {
            display: true,
            text: y_label,
            color: textColor,
          },
          ticks: {
            font: {
              family: "Montserrat, sans-serif",
              size: 16
            },
            color: textColor,
          },
          grid: {
            color: function(context) {
              if(hide_grid_lines === 'true') {
                if (context.index === 0 && hide_axes != 'true') {
                  return textColor;
                }
                return 'rgba(0, 0, 0, 0)'; // Transparent for all other lines
              }
              else {
                if (context.index === 0 && hide_axes != 'true') {
                  return textColor;
                }
                else if(context.index === 0) {
                  return 'rgba(0,0,0,0)';
                }
                return textColor == '#FFFFFF' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)';
              }
            },
          }
        }
      },
      plugins: {
        legend: {
          display: showLegend === 'false' ? false : true,
          position: dataset_labels_position === 'right' ? 'right' : 'bottom',
          labels: {
            font: {
              family: "Montserrat, sans-serif",
              size: 16
            },
            color: textColor,
            padding: 20,
          },
          reverse: dataset_labels_position === 'right' ? true : false,
          onClick: function(e, legendItem, legend) {
            // Call the default legend click behavior first
            Chart.defaults.plugins.legend.onClick.call(this, e, legendItem, legend);
            
            // Force a redraw to update the total labels
            legend.chart.update('none');
          }
        },
        tooltip: {
          titleFont: {
            family: "Montserrat, sans-serif",
            size: 16
          },
          bodyFont: {
            family: "Montserrat, sans-serif",
            size: 16
          }
        },
      }
    },
    plugins: [{
      afterDatasetsDraw: function(chart) {
        if(display_total_sum != 'true') {
          return;
        }
        const ctx = chart.ctx;
        let textColor = document.querySelector('body.body-bg-blue') ? '#FFFFFF' : '#161614';
        if(document.querySelector('#barChart_' + id + '.bg-color-white')) {
          textColor = '#161614';
        }
        // Set font properties for the total labels
        ctx.font = '600 16px Montserrat, sans-serif';
        ctx.fillStyle = textColor;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
  
        // Calculate totals for each bar position
        const totals = [];
        
        // Initialize totals array
        for (let i = 0; i < chart.data.labels.length; i++) {
          totals[i] = 0;
        }
        
        // Sum up all dataset values for each position (only from visible datasets)
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          const meta = chart.getDatasetMeta(datasetIndex);
          
          // Only include visible datasets in the total calculation
          if (!meta.hidden) {
            dataset.data.forEach((dataPoint, index) => {
              // Handle both object format {x: 0, y: value} and direct value
              const value = typeof dataPoint === 'object' ? (dataPoint.y || dataPoint) : dataPoint;
              const numValue = parseFloat(value);
              
              if (!isNaN(numValue)) {
                totals[index] += numValue;
              }
            });
          }
        });
        
        // Draw total labels on top of each stacked bar
        chart.data.labels.forEach((label, index) => {
          if (totals[index] > 0) {
            // Get the bar elements for this index from all datasets
            let topY = null;
            let barX = null;
            
            // Find the topmost bar segment for this index
            chart.data.datasets.forEach((dataset, datasetIndex) => {
              const meta = chart.getDatasetMeta(datasetIndex);
              if (meta.data[index]) {
                const bar = meta.data[index];
                barX = bar.x; // Get x position from any bar
                
                // For stacked bars, we want the bar with the smallest y value (topmost)
                if (topY === null || bar.y < topY) {
                  topY = bar.y;
                }
              }
            });
            
            if (topY !== null && barX !== null) {
              // Position the label above the topmost bar segment
              const x = barX;
              const y = topY - 15; // 15px above the top
              
              // Format the total
              const formattedTotal = totals[index].toFixed(1);
              
              // Draw the total label
              ctx.fillText(formattedTotal, x, y);
            }
          }
        });
      }
    }]
  });
  if(window.innerWidth <= 600) {
    barChart.options.plugins.legend.position = 'bottom';
    barChart.update();
  }
}

if(blocks.length > 0) {
  window.setupChart = setupChart;
}